import { takeEvery, put, call, all } from "redux-saga/effects";
import apiCall from "../services";

const apiUrl = process.env.REACT_APP_API_URL;
const enviromentUrl = process.env.REACT_APP_ENVIROMENT;

function* getParticipantsCategory(actions) {

  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = apiUrl + "/opa-product-participant/" + actions.productUuid;;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "GET", url, requestOptions);

    yield put({ type: "RESPONSE_GET_PARTICIPANTS_CATEGORY", value: response });
  } catch (error) {
    yield put({ type: "RESPONSE_GET_PARTICIPANTS_CATEGORY", value: error });
  }
}

function* createParticipantsCategory(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-product-participant/" + actions.productUuid;;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";

    if (response) {
      if (response.createdAt) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({ type: "RESPONSE_CREATE_PARTICIPANTS_CATEGORY", value: { ...response, responseStatus } });
    return response;

  } catch (error) {
    yield put({ type: "RESPONSE_CREATE_PARTICIPANTS_CATEGORY", value: { ...error, responseStatus: "error" } });
    throw error;
  }
}

function* updateParticipantsCategory(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-product-participant/" + actions.productUuid + "/" + actions.categoryUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.updatedAt) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({ type: "RESPONSE_UPDATE_PARTICIPANTS_CATEGORY", value: { ...response, responseStatus }, });
    return response;
  } catch (error) {
    yield put({ type: "RESPONSE_UPDATE_PARTICIPANTS_CATEGORY", value: { ...error, responseStatus: "error" }, });
    throw error;
  }
}

function* deleteParticipantsCategory(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-product-participant/" + actions.productUuid + "/" + actions.categoryUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.status === 200) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({ type: "RESPONSE_DELETE_PARTICIPANTS_CATEGORY", value: { ...response, responseStatus }, });
    return response;
  } catch (error) {
    yield put({ type: "RESPONSE_DELETE_PARTICIPANTS_CATEGORY", value: { ...error, responseStatus: "error" }, });
    throw error;
  }
}


export function* getSagaParticipantsCategoryList() {
  yield takeEvery("GET_LIST_PARTICIPANTS_CATEGORY", getParticipantsCategory);
}

export function* deleteSagaParticipantsCategory() {
  yield takeEvery("DELETE_PARTICIPANTS_CATEGORY", deleteParticipantsCategory);
}

export function* updateSagaParticipantsCategory() {
  yield takeEvery("UPDATE_PARTICIPANTS_CATEGORY", updateParticipantsCategory);
}

export function* createSagaParticipantsCategory() {
  yield takeEvery("CREATE_PARTICIPANTS_CATEGORY", createParticipantsCategory);
}


const getSetCookie = () => {
  return window.localStorage.getItem("uuidSetCookie");
};
